import { graphql, useStaticQuery } from "gatsby"

const useCompanyInfo = () => {
  const data = useStaticQuery(graphql`
    query {
      strapiSiteConfig {
        Site_Contact {
          data {
            Site_Contact
          }
        }
        facebook_link
        email
        address
        id
        instagram_link
        linkedin_link
        name
        phone
        strapi_id
        twitter_link
      }
    }
  `)

  const {
    Site_Contact,
    facebook_link,
    email,
    address,
    id,
    instagram_link,
    linkedin_link,
    name,
    phone,
    strapi_id,
    twitter_link,
  } = data.strapiSiteConfig

  return {
    Site_Contact,
    facebook_link,
    email,
    address,
    id,
    instagram_link,
    linkedin_link,
    name,
    phone,
    strapi_id,
    twitter_link,
  }
}

export default useCompanyInfo
